const ARROW_DOWN = 'ArrowDown';
const ARROW_UP = 'ArrowUp';
const ESCAPE = 'Escape';
const ENTER = 'Enter';
const SPACE = ' ';
const TAB = 'Tab';
export { ARROW_DOWN, ARROW_UP, ENTER, ESCAPE, SPACE, TAB };
//# sourceMappingURL=keyboard-events.js.map